import api from '../config/api';
const TOKEN = localStorage.getItem('token');
const header = TOKEN ? {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer ' + TOKEN
} : { 'Content-Type': 'application/json' };

const API = new api({ headers: header });

//AUTH API
const AuthAPI = {
  postLogin: (payload) => API.post('auth/login', payload),
  postForgotPassword: (payload) => API.post('auth/forgot-password', payload),
  postResetPassword: (payload) => API.post('auth/reset-password', payload),
  postVerifyPassword: (payload) => API.post('/auth/forgot-password/verify', payload),
  postGetMenu: (payload) => API.post('/menu-access', payload),
};

// FORM API
const FormModuleAPI = {
  getModule: () => API.get('form-model'),
  postModule: (payload) => API.post('form-model/create', payload),
  updateModule: (payload, param) => API.put(`form-model/module/${param}`, payload),
  deleteModule: (payload) => API.delete(`form-model/module/${payload}`),
  getSubModule: (payload) => API.get(`form-model/${payload}`),
  postSubModule: (payload, param) => API.post('form-model/submodule', payload, param),
  postCloneSubModule: (payload, param) => API.post('submodule/clone', payload, param),
  postCloneModule: (payload) => API.post('form-model/duplicate-form', payload),
  updateSubModule: (payload, param) => API.put('form-model/submodule', payload, param),
  deleteSubModule: (payload) => API.delete('form-model/submodule', payload),
  postYItem: (payload, param) => API.post('form-model/yItem', payload, param),
  updateYItem: (payload, param) => API.put('form-model/yItem', payload, param),
  deleteYItem: (payload) => API.delete('form-model/yItem', payload),
  postXItem: (payload, param) => API.post('form-model/xItem', payload, param),
  updateXItem: (payload, param) => API.put('form-model/xItem', payload, param),
  deleteXItem: (payload) => API.delete('form-model/xItem', payload),
  postApproveSchedule: (payload) => API.post('form-model/approve', payload),
  postRejectSchedule: (payload) => API.post('form-model/reject', payload),
  getPreviewMobileQR: (payload) => API.post(`qrcode/generate`, payload),
};

const AssetAPI = {
  getAsset: () => API.get('asset'),
  getAssetDetail: (param) => API.get('asset/detail', param),
  deleteAsset: (payload) => API.delete(`asset/delete?assetId=${payload}`),
  postAsset: (payload) => API.post('asset/add', payload),
  updateAsset: (payload, param) => API.put('asset/update', payload, param),
  postAssetQr: (payload) => API.post('qrcode/generate', payload),
  putAssetToLayout: (payload) => API.put(`asset/add-to-layout`, payload),
};

const RoleAccessAPI = {
  getRoleAccess: () => API.get('role-access'),
  getAllRoleAccess: () => API.get('role-access/list'),
  getMenuAccessByRole: (payload) => API.get('role-access/menu-access', payload),
  postAddRoleAccess: (payload) => API.post('role-access/add', payload),
  postAddMenuAccess: (payload) => API.post('role-access/add-menu-access', payload),
  updateRoleAccess: (payload, param) => API.put('role-access/update', payload, param),
  deleteRoleAccess: (payload) => API.delete('role-access/delete', payload)
};

const UserAPI = {
  getUserProfile: () => API.get('user/profile'),
  getUserList: () => API.get('user/list'),
  deleteUser: (payload) => API.delete(`/user/delete?userId=${payload}`),
  postUser: (payload) => API.post('user/register', payload),
  updateUser: (payload, param) => API.put('user/update', payload, param)
};

const ParamAPI = {
  getList: (payload) => API.get('parameter', { params: payload })
};

const AbsensiAPI = {
  getAbsensi: (payload) => API.get('getattendancelist', { params: payload }),
  getAbsensiDetail: (payload) => API.get('getattendancedetail', { params: payload })
};

const ScheduleAPI = {
  postSchedule: (payload) => API.post('schedule/submit', payload),
  getScheduleList: () => API.get('schedule/get-list-calendar'),
  postChangeScheduleStatus: (payload, param) => API.post('schedule/update-event', payload, param),
  getDetailSchedule: (param) => API.get('/schedule/get-detail', param),
  getScheduleByStatus: (param) => API.get('schedule/get-list', param),
  postChangeStatus: (payload) => API.post('schedule/change-status', payload),
  postEventSchedule: (payload) => API.post('schedule/submit-sepecial-event', payload),
};

const LayoutAPI = {
  postLayout: (payload) => UploadServices('layout-zone/add', payload),
  getAllLayout: () => API.get('layout-zone/get-list'),
  getDetailLayout: (param) => API.get('layout-zone/get', param),
  updateLayout: (payload, param) => UploadServices('layout-zone/update', payload, param),
  deleteLayout: (param) => API.post('layout-zone/delete', null, param),
  getLayoutAssetCoordinates: (param) => API.get(`layout-zone/get-coordinate`, param),
};

const JobListAPI = {
  getAllJobList: (params) => API.get('joblist', { params }),
  getJobListByParam: (param) => API.get('joblist', param),
  getJobListByID: (param) => API.get(`joblist-byId/${param}`),
  getJobFileByID: (param) => API.get(`get-job-file/${param}`)
}

const PublicWebAPI = {
  getPublicWeb: () => API.get('get-public-web'),
  getPublicWebPage: () => API.get('get-public-web-page'),
  addPublicWeb: (payload) => API.post('set-public-web', payload),
  postVisitorForm: (payload) => API.post('submit-visitor', payload),
  getQRCode: (payload) => API.post('qrcode/generate', payload),
  postRegisterEmployee: (payload) => API.post('register-employee', payload),
  postLoginEmployee: (payload) => API.post('login-employee', payload),
  putVerifyEmployee: (param) => API.put(`verify-employee?id=${param}`)
};

const VehicleListAPI = {
  getLogList: (param) => API.get('vehicle-log-list-summary?keywords&date'),
  getVehicleLogDetail: (param) => API.get(`vehicle-log-detail?id=${param}`)
};

const ComplaintListAPI = {
  getComplaintList: (param) => API.get('complaint-get-list-summary', param),
  getComplaintDetail: (param) => API.get('complaint-get-detail', param),
};

const BuildingZoneLayoutAPI = {
  getZoneLayout: () => API.get('layout-zone/get-list')
};

const VisitorListAPI = {
  getVisitorList: (param) => API.get('visitor/get-visitor-list-summary'),
  getVisitorDetail: (param) => API.get(`visitor/get-visitor-detail?visitorId=${param}`)
};

const LightingAPI = {
  getDashboardStatus: (payload) => API.get('dashboard', { params: payload }),
  getLightingStatus: () => API.get('node/status'),
  setLightingStatus: (payload) => API.patch('node/status', payload),
};

const DevicesAPI = {
  getListDevice: () => API.get('nodes'),
  getStatusDevice: (id) => API.get(`node/${id}/status`),
  setStatusDevice: (payload, id) => API.patch(`node/${id}/status`, payload),
}

const DashboardAPI = {
  getDashboardAssetSummary: (params) => API.get(`dashboard/asset-summary`, { params }),
}

const BasAPI = {
  postBasControl: (payload) => API.post(`bas-control/add`, payload),
  getBasControl: (params) => API.get(`bas-control/get`, { params }),
  putBasControlAction: (payload, params) => API.put(`bas-control/action`, payload, { params }),
}

const UploadServices = (url, payload, param) => {
  return API.post(url, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    ...param
  });
};

const Services = {
  ...AuthAPI,
  ...FormModuleAPI,
  ...AssetAPI,
  ...RoleAccessAPI,
  ...UserAPI,
  ...ParamAPI,
  ...LayoutAPI,
  ...AbsensiAPI,
  ...ScheduleAPI,
  ...JobListAPI,
  ...PublicWebAPI,
  ...VehicleListAPI,
  ...ComplaintListAPI,
  ...BuildingZoneLayoutAPI,
  ...VisitorListAPI,
  ...LightingAPI,
  ...DevicesAPI,
  ...DashboardAPI,
  ...BasAPI,
};

export default Services;
